import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles(theme => ({
    container: {
        backgroundColor: '#F3F5F9',
    },
}));

export default useStyle;
